import React from 'react'
import { Box } from '@material-ui/core'
import { storiesOf } from '@storybook/react'

import { Player } from 'protos'
import PlayerComparisonTable from 'components/PlayerComparisonTable'

const stories = storiesOf('PlayerComparisonTable', module)

const players = [
  Player.create({
    cost: 7,
    averageScore: 145,
    previousMatchScore: 64,
    averageMinutesPlayed: 88,
    averageScorePerMinute: 5,
  }),
  Player.create({
    cost: 5,
    averageScore: 86,
    previousMatchScore: 100,
    averageMinutesPlayed: 80,
    averageScorePerMinute: 3,
  }),
]

stories.addDecorator(story => (
  <Box p={2}>
    {story()}
  </Box>
))

stories.add('default', () => (
  <PlayerComparisonTable players={players} />
))
